module.exports = __webpack_public_path__ + "static/img/zhoubian.d24bacf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhoubian.png
// module id = DH29
// module chunks = 1